import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private readonly measurementId = environment.googleAnalyticsId;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  initialize(): void {
    if (!this.measurementId) return;

    const loaderScript = this.document.createElement('script');
    loaderScript.async = true;
    loaderScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    this.document.head.appendChild(loaderScript);

    const initScript = this.document.createElement('script');
    initScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${this.measurementId}');
    `;
    this.document.head.appendChild(initScript);
  }

  trackPageView(url: string): void {
    if (!this.measurementId || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', { page_path: url });
  }

  trackEvent(eventName: string, params: Record<string, unknown> = {}): void {
    if (!this.measurementId || typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, params);
  }
}
